export default parseInt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/to-integer.js
// module id = 71
// module chunks = 0